<script lang="ts">
	import FindOrderForm from "$lib/components/track-order/FindOrderForm.svelte"
	import { t } from "svelte-i18n-lingui"
	import type { TrackOrderComponent } from "$lib/js/strapi/types"
	import { getContextScope } from '$lib/js/helpers/i18n'

  export let component : TrackOrderComponent
  export let icon = ''

	const scope = getContextScope()
</script>


{#if component.title}
  <h2 class="head-3">{#if icon} <span class="icon icon-{icon}" /> {/if}{@html component.title}</h2>
{/if}

<div class="block">
  <div class="form">
    <p class="lead-1">{$t`Access the order tracking page`}</p>
    <p class="subtitle">{$t`Here you can check the status of your order, track the shipment, and manage any issues with it.`}</p>
    <FindOrderForm type="bg" action="order-status"/>
  </div>

  <div class="account">
    <div class="registered">
      <p>{$t`If you`} <a href="/{scope}/customer/account/login" rel="external">{$t`register`}</a> {$t`or`} <a href="/{scope}/customer/account/login" rel="external">{$t`log in`}</a>
        {$t`to your customer account, you can also perform these actions more quickly and easily.`}
      </p>
    </div>
  </div>
</div>


<style lang="scss">
  h2 {
    font-weight: 900;

    @media (min-width: 769px) {
      padding-bottom: 15px;
    }

    .icon {
      font-weight: 400;
      font-size: 20px;
      margin-right: 15px;

      @media (min-width: 769px) {
        font-size: 28px;
      }
    }
  }

  .block {
    background-color: var(--grey);
    padding: 25px 0 30px;

    @media (min-width: 769px) {
      display: flex;
      padding: 50px 0;
    }

    .form {
      padding: 0 20px;

      @media (min-width: 769px) {
        box-sizing: border-box;
        border-right: 1px solid;
        width: 50%;
        padding: 0 45px;
      }

      .subtitle {
        margin-bottom: 18px;
      }

      p.lead-1 {
        font-size: 16px;
        font-weight: 700;
        margin-bottom: 10px;
      }

    }

    .account {
      @media (min-width: 769px) {
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 50%;
      }
    }

    .registered {
      border: 1px solid var(--black);
      border-radius: 15px;
      padding: 15px;
      margin: 40px 20px 0;

      @media (min-width: 769px) {
        margin-top: 0px;
        padding: 20px 25px;
        font-size: 16px;
        max-width: 350px;
      }

      p {
        margin-bottom: 0;
      }
    }
  }

</style>